import { type ReactNode } from 'react';
import cx from 'clsx';
import { create } from 'qrcode';
import styles from './qr-code.module.css';

export interface QrCodeProps {
  url?: string;
  fallbackSrc?: string;
  className?: string;
}

export function QrCode({ url, fallbackSrc, className }: QrCodeProps): ReactNode {
  if (url) {
    const { modules } = create(url, { errorCorrectionLevel: 'M' });
    const { size, data } = modules;
    return (
      <svg
        aria-hidden="true"
        className={cx(styles.img, className)}
        data-test-qr-code
        fill="#000000"
        viewBox={`0 0 ${size} ${size}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        {Array.from(data).map((bit, i) => {
          const x = i % size;
          const y = Math.floor(i / size);
          return bit ? <rect key={`${x}-${y}`} height={1} width={1} x={x} y={y} /> : null;
        })}
      </svg>
    );
  }

  return <img alt="" className={cx(styles.img, className)} src={fallbackSrc} />;
}
